import { GroupedDropdownEditor, AxisSwitcherEditor } from './filterKindForms';

// Catalog of the special filter widget kinds (beyond the generic
// checkboxes / radio / dropdown). The settings form builds the Widget dropdown
// from these and renders a kind's sub-form when it's picked; runtime consumers
// read the same filter config. Adding a kind = one entry here plus its form in
// filterKindForms.

// Every entry has the same shape — { kind, label } plus an optional `Editor`
// for the kinds that need their own sub-form — so the settings form can build
// the Widget dropdown from any of these lists without special-casing.

// Generic row-filter widgets — narrow which rows are shown. No sub-form: the
// settings form falls through to its shared facet editor for these.
export const GENERIC_FILTER_KINDS = [
  { kind: 'checkboxes', label: 'Checkboxes' },
  { kind: 'radio', label: 'Radio' },
  { kind: 'dropdown', label: 'Dropdown' },
];

// Special row-filter kinds: grouped dropdown, etc.
export const ROW_FILTER_KINDS = [
  { kind: 'grouped-dropdown', label: 'Grouped dropdown', Editor: GroupedDropdownEditor },
];

// Axis-control kinds: change what is plotted, not which rows are shown.
export const AXIS_FILTER_KINDS = [
  { kind: 'axis-switcher', label: 'Axis metric switcher', Editor: AxisSwitcherEditor },
];

// All special kinds combined — used for Editor lookup and kind detection.
export const FILTER_KINDS = [...ROW_FILTER_KINDS, ...AXIS_FILTER_KINDS];
